import { Img, Section, Link, Text, Row, Column } from "@react-email/components";

const headerLinks = (utm_campaign) => [
	{
		href: `https://offcutshades.com/shop?utm_source=header_menu&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`,
		text: "Design Your Shade",
	},
	{
		href: `https://offcutshades.com/wallpaperinit?utm_source=header_menu&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`,
		text: "Wallpaper",
	},
	{
		href: `https://offcutshades.com/swatches?utm_source=header_menu&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`,
		text: "Free Samples",
	},
	{
		href: `https://offcutshades.com/contact?utm_source=header_menu&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`,
		text: "Contact",
	},
];

const styles = {
	center: {
		margin: "0 auto",
		textAlign: "center",
		display: "block",
	},
	header: {
		fontSize: "30px",
	},
	headerText: {
		fontSize: ".8rem",
		color: "initial",
	},
	navBar: {
		verticalAlign: "text-top",
		fontSize: ".8rem",
		width: `${100 / headerLinks("utm").length}%`,
	},
	navLink: {
		color: "initial",
		textDecoration: "underline",
	},
};

function HeaderBadge({ utm_campaign }) {
	return (
		<Row>
			<Link
				target="_blank"
				href={`https://offcutshades.com/?utm_source=header_menu&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`}
			>
				<Img
					src="https://offcutshades.com/images/email/offcutshadeslogo.png"
					alt="Off Cut Shades"
					title="Off Cut Shades"
					width={200}
					style={styles.center}
				/>
				<Text style={styles.headerText}>Shading Solutions Simplified</Text>
			</Link>
		</Row>
	);
}

function HeaderNavBar({ utm_campaign }) {
	return (
		<nav>
			<Row>
				{headerLinks(utm_campaign).map((link) => (
					<Column style={styles.navBar}>
						<Link href={link.href} style={styles.navLink}>
							{link.text}
						</Link>
					</Column>
				))}
			</Row>
		</nav>
	);
}

export default function Header({ withNavBar, utm_campaign }) {
	return (
		<Section>
			<header style={styles.header}>
				<HeaderBadge utm_campaign={utm_campaign} />
				{withNavBar ? <HeaderNavBar utm_campaign={utm_campaign} /> : null}
			</header>
		</Section>
	);
}
